const Auth = {
  Login: '/login',
  Verify: '/verify',
  Signup: '/sign-up',
  Callback: '/auth/callback',
  SsoCallback: '/sso/callback',
  SelectVerify: '/select-verify',
  ForgotPassword: '/forgot-password',
  SsoIdpStartLogin: '/sso/idp/start-login',
};

const Dashboard = {
  Home: '/dashboard',
};

const GetStarted = {
  Home: '/get-started',
};

const AdditionalInfo = {
  Home: '/additional-info',
};

const Resources = {
  Home: '/resources',
};

const Course = {
  Form: '/forms/:id',
  Resource: '/resources/:id',
};

const Profile = {
  Home: '/profile',
};

export const Routes = {
  Auth,
  Course,
  Profile,
  Home: '/',
  Dashboard,
  Resources,
  GetStarted,
  AdditionalInfo,
  NotFound: '/404',
};
